jQuery(function ($) {
  $(document).ready(function () {
    $(".swatch").on("click", function () {
        
      // Get Linked Elements
      let linkedSelectedImage = this.dataset.linkedImage;
      let swatchColor = this.dataset.color;
      let linkedDisplayName = this.dataset.linkedDisplayName;

      //Update Text
      $(`#${linkedDisplayName}`).text(swatchColor);

      // Update Selected Image
      $(`#${linkedSelectedImage}`)
        .addClass("selected")
        .siblings()
        .removeClass("selected");
    });
  });
}); 